"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRole = void 0;
// eslint-disable-next-line import/prefer-default-export
function hasRole(state, role) {
    var auth = state.auth, user = state.user;
    if (auth.authenticationDisabled) {
        return true;
    }
    var roles = user.authenticated ? user.roles : [];
    return roles.includes(role);
}
exports.hasRole = hasRole;
